import axios from 'axios';

import { MAIN_URL_API, API_PATHS } from '../config/mainConfig';

export async function sendEmailContact(payload) {
  return axios.post(`${MAIN_URL_API}${API_PATHS.SEND_EMAIL}`, payload)
    .then(res => { return true })
    .catch(error => { return false });
};
